import React from "react";
import classes from "./login.module.css";
import {
   Box,
   TextField,
   Button,
   InputAdornment,
   IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import UrbcLogo from "../../../components/urbc-logo/urbc-logo";
import { Link } from "react-router-dom";
import { validators } from "../../../../utilities/inputValidator";
import useInput from "../../../../hooks/useInput";
import useAuth from "../../../../hooks/useAuth";
import Spinner from "../../../components/spinner/spinner";
import { useSelector } from "react-redux";

const Login = () => {
   const {
      value: emailValue,
      hasError: emailHasError,
      valueIsValid: emailValueIsValid,
      inputBlurHandler: emailInputBlurHandler,
      valueInputChange: emailValueInoutChange,
   } = useInput(validators.checkEmailIsValid);

   const {
      value: passwordValue,
      hasError: passwordHasError,
      valueIsValid: psswordValueIsValid,
      inputBlurHandler: passwordInputBlurHandler,
      valueInputChange: passwordValueInoutChange,
      showPassword,
      onSetShowPassword,
   } = useInput(validators.checkPasswordIsValid);

   const {
      auth: { loading },
   } = useSelector((state) => state);

   const { loginUser } = useAuth();

   const formIsValid = emailValueIsValid && psswordValueIsValid;

   const handleSubmit = (e) => {
      e.preventDefault();

      const reqBody = {
         username: emailValue,
         password: passwordValue,
         grant_type: "password",
      };

      loginUser(reqBody);
   };

   return (
      <Box className={classes.login}>
         <Box className={classes.loginForm}>
            <form onSubmit={handleSubmit}>
               <Box className={classes.Form}>
                  <Box>
                     <UrbcLogo />
                  </Box>
               </Box>
               <Box className={classes.Email}>
                  <TextField
                     type="text"
                     sx={{ background: "white" }}
                     variant="outlined"
                     label="Email"
                     fullWidth
                     value={emailValue}
                     onChange={emailValueInoutChange}
                     onBlur={emailInputBlurHandler}
                     error={emailHasError}
                  />
               </Box>
               <Box className={classes.Password}>
                  <TextField
                     id="input-with-icon-textfield"
                     sx={{ background: "white" }}
                     type={showPassword ? "text" : "password"}
                     label="Password"
                     value={passwordValue}
                     onChange={passwordValueInoutChange}
                     onBlur={passwordInputBlurHandler}
                     error={passwordHasError}
                     InputProps={{
                        endAdornment: (
                           <InputAdornment position="end">
                              <IconButton
                                 aria-label="toggle password visibility"
                                 onClick={onSetShowPassword}
                                 edge="end"
                              >
                                 {showPassword ? (
                                    <VisibilityOff />
                                 ) : (
                                    <Visibility />
                                 )}
                              </IconButton>
                           </InputAdornment>
                        ),
                     }}
                     variant="outlined"
                     fullWidth
                  />
               </Box>
               <Box className={classes.Button}>
                  <Button
                     sx={{ background: "#001A72" }}
                     className={classes.loginButton}
                     type="submit"
                     variant="contained"
                     disabled={!formIsValid || loading}
                  >
                     Login
                  </Button>
                  {loading && <Spinner />}
                  <p>
                     <Link to="/forgot-password">Forgot password?</Link>
                  </p>
               </Box>
            </form>
         </Box>
      </Box>
   );
};

export default Login;
